import React from "react";
import { CreateContainer } from "./ContainerCreate";
import { getRecentTracks } from "../api/getTrack";
import Skeleton from "react-loading-skeleton";

class TrackRecentContainer extends React.Component {
  componentDidMount() {
    this.props.request();
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const tracks = (data && data.data) || [];
    if (loading) {
      return <Skeleton count={3} />;
    }
    if (!loading && tracks.length === 0) {
      return null;
    }
    return render({ tracks, loading, failure });
  };
}

export default CreateContainer(getRecentTracks, TrackRecentContainer);
